//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['noDeleteSlugs'],
    data: function data() {
        return {
            url: route('sanctum_api.pages.index'),
            columns: [{
                name: 'slug',
                label: trans('columns.slug'),
                sortable: true
            }, {
                name: 'title',
                label: trans('columns.title'),
                sortable: true
            }, {
                name: 'lang',
                label: trans('columns.lang'),
                sortable: true
            }, {
                name: 'last_edited_by',
                label: trans('columns.last_edited_by'),
                sortable: false,
                data: function data(item) {
                    return item.last_edited_by ? item.last_edited_by.name : '–';
                }
            }]
        };
    },

    methods: {}
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/Pages.vue
// module id = 55
// module chunks = 0